import React, { useEffect, useRef, useState, useCallback } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faPlus,
  faSort,
  faEllipsisVertical,
  faTrash,
  faPenToSquare,
  faUser,
  faEnvelope,
  faMobile,
  faCamera,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "react-bootstrap/Modal";
import clientDemoImg from "../assets/img/pro-logo.png";
import Menus from "./menus";
import { useNavigate, Link } from "react-router-dom";
import { commonAPI } from "../services/CommonAPIService";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorSource } from "../common/constants";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Offline, Online } from "react-detect-offline";
import NoInternet from "./Nointernet";
import ChangePasswordImg from "../assets/img/Changekey.png";

function Profile() {
  const history = useNavigate();
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [Loading, setLoading] = useState(false);
  const [UserData, setUserData] = useState({});
  const [show, setShow] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({ unit: '%', width: 80, height: 150, aspect: 1 });
  const [completedCrop, setCompletedCrop] = useState({ unit: 'px', x: 0, y: 0, width: 144, height: 144 });
  const [PreviewShow, setPreviewShow] = useState(false);
  const [PreviewTrigger, setPreviewTrigger] = useState(false);
  const [CurrentPassword, setCurrentPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    const storedUsername = localStorage.getItem('userData');
    const myUserData = JSON.parse(storedUsername);
    if (storedUsername) {
      history('/Profile');
    } else if (storedUsername === null) {
      history('/');
    }
  }, [history]);

  const openCreateModal = () => {
    setShow(true);
    if (UserData?.userImage) {
      setSelectedImage(UserData?.userImage);
    } else {
      setSelectedImage("");
    }
    setCrop({ unit: '%', width: 84, height: 84, aspect: 1 });
    setPreviewShow(false);
  };

  const MyProfileData = async () => {
    const auth = localStorage.getItem("userData");
    const myUserData = JSON.parse(auth);
    setUserData(myUserData);
  };

  useEffect(() => {
    MyProfileData();
  }, []);

  const getCroppedImg = (image, crop, fileName, backgroundColor = 'white') => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;

    const ctx = canvas.getContext('2d');
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        const fileUrl = window.URL.createObjectURL(blob);
        resolve({ fileUrl, blob });
      }, 'image/jpeg');
    });
  };

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }
    console.log("test Update UseEffect")
    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;
    console.log("canvas Update UseEffect", canvas)
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width;
    canvas.height = crop.height;

    ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    setPreviewShow(true);
  }, [completedCrop, selectedImage, PreviewTrigger]);

  const UpdateImage = async () => {
    try {
      setLoading(true);
      const { blob } = await getCroppedImg(imgRef.current, completedCrop, 'newFile.jpeg');
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        const base64data = reader.result.split("base64,")[1];
        const bodydata = { 
          "userId": UserData?.userId,
          "userImage": reader.result,
          "modifiedUserId": JSON.stringify(UserData?.userId),
        };
        let response = await commonAPI("UserImage", bodydata);
        if (response.success === true && response.message.length === 0) {
           const bodyData = { 
            "userId": UserData?.userId,
            "userImageRequired": true,
            "buildingLogoRequired": false
          };
          let responseMapping = await commonAPI("GetCuroNextUserMapping", bodyData)
          console.log("responseMapping", responseMapping)
          if (responseMapping.success === true && responseMapping.message.length === 0) {
            toast.success("Profile Updated");
            setLoading(false);
            setShow(false);
            history("/Profile");
            window.location.reload(); 
            const dataToUpdate = {
              ...UserData,
              userImage: responseMapping?.data[0]?.userImage,
            };
            localStorage.setItem("userData", JSON.stringify(dataToUpdate));
            MyProfileData();
          } else {  
            toast.error(responseMapping.message[0]);
            setLoading(false);
          }
        } else {
          toast.error(response.message[0]);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      const bodyError = { 
        "userId": UserData.userId,
        "mobileNumber": UserData.mobileNumber,
        "requestJSON": null,
        "uri": "/api/User/UserImage",
        "errorNumber": "PU01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Profile.js",
        "functionName": "UpdateImage",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      if (response.success === true && response.message.length === 0) {
        toast.error("Something went wrong");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const UpdatePassword = async () => {
    try {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;

      if (!CurrentPassword) {
          toast.warning("Please enter Current Password");
          return;
      }
      if (!NewPassword) {
          toast.warning("Please enter New Password");
          return;
      }
      if (!ConfirmPassword) {
          toast.warning("Please enter Confirm Password");
          return;
      }

      // Check if NewPassword meets the regex criteria
      if (!regex.test(NewPassword)) {
          toast.warning("New Password must include a lowercase, uppercase, digit, special character, and be 8-20 characters.");
          return;
      }

      // Check if NewPassword and ConfirmPassword match
      if (NewPassword !== ConfirmPassword) {
          toast.warning("New Password and Confirm Password do not match.");
          return;
      }

      
    
      
      setLoading(true);
      const bodydata = { 
        "userId": UserData?.userId,
        "currentPassword": CurrentPassword,
        "newPassword": NewPassword,
        "modifiedUserId": JSON.stringify(UserData?.userId),
      };
      let response = await commonAPI("ChangePassword", bodydata);
      if (response?.success === true && response?.message.length === 0) {
        toast.success("Password Updated");
        setLoading(false);
        setShowPassword(false);
      } else {
        toast.error(response.message[0]);
        setLoading(false);
      }
     
    } catch (error) {
      setLoading(false);
      const bodyError = { 
        "userId": UserData.userId,
        "mobileNumber": UserData.mobileNumber,
        "requestJSON": null,
        "uri": "/api/User/UserImage",
        "errorNumber": "PU01",
        "errorSource": "CuroNextPortal",
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "Profile.js",
        "functionName": "UpdateImage",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      if (response.success === true && response.message.length === 0) {
        toast.error("Something went wrong");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCrop({ unit: '%', width: 86, height: 86, aspect: 1 })
      setCompletedCrop({ unit: 'px', x: 0, y: 0, width: 143, height: 143 });
      if (!/\.(jpeg|jpg|png)$/i.test(file.name)) {
        toast.error("Please select an image in JPEG, JPG, or PNG format.");
      } else if (file.size >= 50000) {
        toast.error("User Image cannot be more than 50 KB.");
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          setPreviewTrigger((prev) => !prev)
          setCrop({ unit: '%', width: 85, height: 85, aspect: 1 });
          console.log("test 1")
          setCompletedCrop({ unit: 'px', x: 0, y: 0, width: 145, height: 145 });
          console.log("test 2")
          setSelectedImage(reader.result);
        };
       
      }
    }
  };
  


  return (
    <>
      {Loading && (
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
      )}
      
      <Menus />
      <Online>
        <ToastContainer />
        <Modal size="md" show={show} onHide={() => setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
          <Modal.Header closeButton className='headerMDL'>
            <Modal.Title id="contained-modal-title-vcenter">
              Update Profile Image
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="helpingElelemnt_uuy002">

            
          
                <div className="row" id="validation">
                  <div className="col-12">
                
                        <form className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" noValidate>
                          <div className="content clearfix">
                            <div className="row text-left">
                              <div className="col-md-12 mb-2 text-center">
                                <div className="form-group justify-content-start parentUploadContainer text-center mx-auto" style={{ width: "260px" }}>
                                  <div>
                                    {!selectedImage ? (
                                      <div className='img_uploaded profile-img' style={{padding: 40}}><img src={clientDemoImg} className="img img-responsive p-0" alt="client-img" /></div>
                                    ) : (
                                      <>
                                        {PreviewShow ?
                                          <div>
                                          {/* {completedCrop && ( */}
                                            <div>
                                              {/* <h5>Crop Preview:</h5> */}
                                              <canvas
                                                ref={previewCanvasRef}
                                                style={{
                                                  objectFit: "contain",
                                                  width: completedCrop?.width,
                                                  height: completedCrop?.height,
                                                }}
                                              />
                                            </div>
                                          {/* )} */}
                                          </div>
                                        :
                                          <>
                                          {/* {selectedImage ?  */}
                                            <img ref={imgRef} src={selectedImage} style={{width: "180px"}} alt="Selected" />
                                            {/* :<img src={clientDemoImg} className="img img-responsive" alt="client-img" />
                                          } */}
                                          </>
                                          
                                        }
                                      </>  
                                    )}
                                    <label htmlFor="file-upload" className="custom-file-upload mt-2">
                                      Browse Image
                                    </label>
                                    <input id="file-upload" type="file" onChange={(e) => [handleFileInputChange(e), setPreviewShow(true), setCrop({ unit: '%', width: 79, height:79, aspect: 2 }), setCompletedCrop({ unit: 'px', x: 0, y: 0, width: 145, height: 145 })]} />
                                    {/* <img ref={imgRef} alt='Error' src={imageUrl} onLoad={onImageLoad} style={{ display: "none" }} /> */}
                                    <label className="text-danger mb-0 float-left"><span className="danger">*</span> Allowed File Types- JPEG/JPG/PNG.</label>
                                    <label className="text-danger mb-0 float-left"><span className="danger">*</span>Maximum image size - 50KB</label>
                                  </div>

                                  
                                </div>
                                <div className="mt-4">
                                  {PreviewShow ? 
                                    <ReactCrop crop={crop} onChange={setCrop} onComplete={setCompletedCrop}>
                                      <img ref={imgRef} src={selectedImage} style={{width: "180px"}} alt="Selected" />
                                    </ReactCrop>
                                  :null} 
                                  
                                </div>
                                {/* <ReactCrop crop={crop} className="crop__fixed" onChange={c => setCrop(c)} onComplete={setCompletedCrop}>
                                    <img ref={imgRef} src={selectedImageTwo}  alt="Selected" onLoad={onImageLoad} />
                                </ReactCrop> */}
                              </div>
                            </div>
                          </div>
                          
                        </form>
                    
                  
                  </div>
                </div>
            
          
          </Modal.Body>


          <div className="fixed_allbtn">                        
                <div className="upload_btn">
              
                              <div className="align-self-start">
                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                <button type="button" className="btn btn-info" onClick={UpdateImage}> Submit</button>
                              </div>
                            
                                            </div>
  </div>



        </Modal>
        <Modal size="md" show={showPassword} onHide={() => setShowPassword(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton className='headerMDL'>
          <Modal.Title id="contained-modal-title-vcenter">
            Update Password
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="helpingElelemnt_uuy002 pt-3">
          <div className="row" id="validation">
            <div className="col-12">
          
              <form className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" noValidate>
                <div className="content clearfix">
                  <div className="row text-left">
                    <div className="">
                      <div className="form-group justify-content-start  mx-auto">
                        <div className="col-md-12 mb-2 mt-2 pl-1">
                          <div className="form-group">
                            <label for="wfirstName2"> Current Password  <span className="danger">*</span> </label>
                            <input type="password" value={CurrentPassword} onChange={(e)=>{setCurrentPassword(e.target.value)}}  className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> 
                          </div>
                        </div>
                        <div className="col-md-12 mb-2 pl-1">
                          <div className="form-group">
                            <label for="wfirstName2"> New Password  <span className="danger">*</span> </label>
                            <input type="password" value={NewPassword} onChange={(e)=>{setNewPassword(e.target.value)}}  className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> 
                          </div>
                        </div>
                        <div className="col-md-12 pl-1">
                          <div className="form-group">
                            <label for="wfirstName2"> Confirm Password  <span className="danger">*</span> </label>
                            <input type="password" value={ConfirmPassword} onChange={(e)=>{setConfirmPassword(e.target.value)}}  className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> 
                          </div>
                        </div>
                          
                          </div>
                          
                          </div>
                      </div>
                    </div>
                  {/* </div>
                </div> */}
              </form>

            </div>
          </div>
        </Modal.Body>

        <div className="fixed_allbtn pt-0 pb-0">                        
          <div className="upload_btn">
          
            <div className="align-self-start">
              <button type="button" className="btn border bg-white" onClick={() => setShowPassword(false)}> Cancel</button>
              <button type="button" className="btn btn-info" onClick={UpdatePassword}> Submit</button>
            </div>
                      
          </div>
        </div>

      </Modal>
        <div className="container" style={{ marginTop: "100px" }}>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="clientTiles row" style={{ height: "auto" }}>
                <div className="ClientImg col-lg-2 col-md-6 col-sm-12">
                  <div className="profile-div">
                    {/* <img src={"data:image/png;base64," + UserData?.userImage} className="img img-responsive" alt="client-img" /> */}
                    {UserData?.userImage ?
                      <img src={UserData?.userImage} className="img img-responsive" alt="client-img" />
                    :
                      <img src={clientDemoImg} className="img img-responsive" alt="client-img" />
                    }
                    
                    <div className="profile-overlay">
                      <FontAwesomeIcon icon={faCamera} onClick={openCreateModal} className="mt-5 overlay_img" />
                    </div>  
                  </div>
                </div>
                <div className="ClientText col-10">
                  <div className="l-two">
                    <h1>{UserData?.userName}</h1>
                    <div className="row mt-3" style={{ borderTop: "1px solid #dadada", paddingTop: "10px" }}>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <h4><FontAwesomeIcon icon={faUser} className="mr-2" />{UserData?.roleName}</h4>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <h4><FontAwesomeIcon icon={faMobile} className="mr-2" />{UserData?.mobileNumber}</h4>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <h4><FontAwesomeIcon icon={faEnvelope} className="mr-2" /> {UserData?.emailId}</h4>
                      </div>
                      
                      
                    </div>
                    <div className="col-12 text-end">
                      <img src={ChangePasswordImg}  className="mt-5" style={{width: 24}} onClick={() => {setShowPassword(true); setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");}} />
                      {/* <FontAwesomeIcon icon={faCamera} onClick={openCreateModal} className="mt-5" /> */}
                    </div>	
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>    
      </Online>  
      {/* <div style={{ margin: 100, marginTop: -30}}>
        <Offline>
            <NoInternet /> 
        </Offline>
      </div>  */}
    </>
  );
}

export default Profile;
